module.exports = "https://cdn.hellotech.com/client-assets/tv-mounting-mobile_ad3f29fd3f0b80f1c6b69b53c004488e.jpg";